import styled from 'styled-components';

export const QrCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  min-height: fit-content;
  padding-bottom: 5rem;
`;

export const ActionQrCodeArea = styled.div`
  width: 335px;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: -20px;
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const QrCodeTitle = styled.div`
  display: flex;
  font-size: 18px;
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 600;
  margin: 23px auto;
  flex-wrap: wrap;
  max-width: 100%;
`;

export const QrCodeSubTitle = styled.div`
  display: flex;
  color: ${(props) => props.theme.palette.gray3};
  flex-wrap: wrap;
  max-width: 64%;
  margin: 0 auto;
  text-align: center;
`;

export const QrCodeImage = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin: 20px auto;
  background: white;
  padding: 20px;
  box-shadow: 0px 4px 14px ${(props) => props.theme.palette.darkTransparency};
  border-radius: 12px;
`;

export const QrCodeLink = styled.div`
  display: flex;
  color: ${(props) => props.theme.palette.gray1};
  flex-wrap: wrap;
  max-width: 100%;
  margin: 10px auto;
  text-align: center;
  font-size: 14px;
  img {
    margin: 0px 5px;
  }
  a {
    color: ${(props) => props.theme.palette.gray1};
  }
`;

export const QrCodeButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  height: 50px;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 279px;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary.main};
  justify-content: center;
  align-content: center;
  background: transparent;
  margin: 20px auto;
`;

export const PdfContainer = styled.div`
  background: gray;
  display: flex;
  max-width: 100vw;
  height: auto;
  min-height: 3000px;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  margin-bottom: 200px;
  canvas {
    padding-top: 50px;
    padding-bottom: 100px;
    margin: 0 auto;
  }
`;

export const PdfNotFoundContainer = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-top: 120px;
`;

export const NotFoundReaderPdfTitle = styled.div`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary.main};
  text-align: center;
  margin: 20px;
`;

export const NotFoundReaderPdfButton = styled.button`
  display: flex;
  flex-wrap: wrap;
  position: fixed;
  bottom: 20px;
  max-width: 100%;
  height: 50px;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  border-radius: 8px;
  width: 279px;
  text-align: center;
  font-weight: 600;
  color: ${(props) => props.theme.palette.primary.main};
  justify-content: center;
  align-content: center;
  align-self: center;
  background: ${(props) => props.theme.palette.primary.contrastText};

  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;
